"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelStyled = exports.StepperStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const temaPadrao_1 = __importDefault(require("../../../components/CeMuiThemeProvider/temaPadrao"));
exports.StepperStyled = styled_components_1.default(core_1.Stepper) `
  padding: 5px;
  padding-top: 10px;
  ${({ theme = temaPadrao_1.default }) => {
    var _a;
    return `
    ${(_a = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _a === void 0 ? void 0 : _a.down('sm')} {
      .MuiStepLabel-labelContainer {
        display: none;
      }
    }
  `;
}};
`;
exports.LabelStyled = styled_components_1.default.div `
  color: ${({ activeStep, step, theme = temaPadrao_1.default }) => {
    var _a, _b;
    return step <= activeStep
        ? ((_a = theme.palette) === null || _a === void 0 ? void 0 : _a.secondary.main) + ';'
        : ((_b = theme.palette) === null || _b === void 0 ? void 0 : _b.grey.A100) + ';';
}};
`;
//# sourceMappingURL=styles.js.map